<template>
    <div class="administradores">
        <h2 class="subheading grey--text">{{ $t('Administradores') }}</h2>
        <v-container class="my-5">
            <v-dialog v-model="dialog_move_up" max-width="500">
                <v-form
                        @submit.prevent="change_user_to_manager()">
                    <v-card class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{$t('move_up_admin')}}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="dialog_move_up = false">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-autocomplete
                                        autofocus
                                        v-model="email2"
                                        :items="items"
                                        prepend-icon="email"
                                        :loading="isLoading"
                                        :search-input.sync="search2"
                                        item-text="email"
                                        item-value="id"
                                        :placeholder="$t('placeholder_invitados')"
                                        :label="$t('usuarios')"
                                        :error-messages="errores.idUsuario"
                                        :no-data-text="$t('no_resultados')"
                                        clearable
                                >
                                    <template v-slot:selection="data">
                                        <v-chip
                                                :selected="data.selected"
                                                class="chip--select-multi"
                                        >
                                            {{ data.item.email }} - {{ data.item.celular }}
                                        </v-chip>
                                    </template>
                                    <template v-slot:item="data">
                                        {{ data.item.email }} - {{ data.item.celular }}, {{data.item.first_name}} {{data.item.last_name}}
                                    </template>
                                </v-autocomplete>
                            </v-layout>
                            <v-layout row wrap>
                                <v-autocomplete
                                        v-model="id_empresa2"
                                        prepend-icon="business"
                                        name="id_empresa2"
                                        item-text="name"
                                        item-value="id"
                                        :label="$t('Empresa')"
                                        :filter="customFilter"
                                        :error-messages="errores.idEmpresa"
                                        :items="empresas"
                                        no-data-text="Ningún Resultado"
                                        clearable
                                ></v-autocomplete>
                            </v-layout>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                    color="primary"
                                    @click="dialog_move_up = false"
                            >
                                {{$t('cerrar')}}
                            </v-btn>
                            <v-spacer/>
                            <v-btn
                                    color="primary"
                                    :loading="loading"
                                    @click="change_user_to_manager()"
                            >
                                {{$t('modificar')}}
                                <v-icon dark right>arrow_upward</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
            <!--    Diálogo  Modal para mostrar mensaje Número de Celular incorrecto    -->
            <v-dialog v-model="dialogCellNumberWrong" persistent max-width="290">
                <v-card justify-center>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('aviso')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text class="justify-center">
                        <br>
                        {{$t('cellphone_wrong')}}
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="primary" @click="dialogCellNumberWrong = false, dialog = true">{{$t('aceptar')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Frontal      -->
            <v-dialog v-model="dialog_img_frontal" persistent scrollable max-width="700px">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('recortar_imagen')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text outlined>
                        <clipper-fixed
                                ref="clipper"
                                :rotate="degrees"
                                :ratio="ratio"
                                :src="imageIneFrenteURL">
                        </clipper-fixed>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-layout row wrap class="justify-center">
                            <v-flex xs12>
                                <v-radio-group
                                        class="justify-center"
                                        v-model="ratio"
                                        name="ratio"
                                        row
                                        label="Ratio"
                                        :mandatory="false"
                                >
                                    <v-radio label="1:1" :value="1"></v-radio>
                                    <v-radio label="3:2" :value="1.5"></v-radio>
                                    <v-radio label="4:3" :value="1.3333333333333333"></v-radio>
                                    <v-radio label="16:9" :value="1.7777777777777777"></v-radio>
                                </v-radio-group>
                            </v-flex>
                            <v-flex xs12>
                                <v-slider
                                        class="justify-center mr-3"
                                        v-model="degrees"
                                        :label="$t('grados')"
                                        step="1"
                                        max="180"
                                        min="-180"
                                        thumb-label="always"
                                ></v-slider>
                            </v-flex>
                            <v-btn
                                    color="primary"
                                    @click="get_image_recortada()"
                            >{{$t('recortar')}}</v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Atrás      -->
            <v-dialog v-model="dialog_img_atras" persistent scrollable max-width="700px">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('recortar_imagen')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <clipper-fixed
                                ref="clipper2"
                                :rotate="degrees"
                                :ratio="ratio"
                                :src="imageIneAtrasURL">
                        </clipper-fixed>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-layout row wrap class="justify-center">
                            <v-flex xs12>
                                <v-radio-group
                                        class="justify-center"
                                        v-model="ratio"
                                        name="ratio"
                                        row
                                        label="Ratio"
                                        :mandatory="false"
                                >
                                    <v-radio label="1:1" :value="1"></v-radio>
                                    <v-radio label="3:2" :value="1.5"></v-radio>
                                    <v-radio label="4:3" :value="1.3333333333333333"></v-radio>
                                    <v-radio label="16:9" :value="1.7777777777777777"></v-radio>
                                </v-radio-group>
                            </v-flex>
                            <v-flex xs12>
                                <v-slider
                                        class="justify-center mr-3"
                                        v-model="degrees"
                                        :label="$t('grados')"
                                        step="1"
                                        max="180"
                                        min="-180"
                                        thumb-label="always"
                                ></v-slider>
                            </v-flex>
                            <v-btn
                                    color="primary"
                                    @click="dialog_img_atras = false, get_image_recortada_atras()"
                            >{{$t('recortar')}}</v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!--     Diálogo Modal Persistente para Recortar la Foto de perfil      -->
            <v-dialog v-model="dialog_img_perfil" persistent scrollable max-width="700px">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('recortar_imagen')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <clipper-fixed
                                class="basic lg"
                                :src="imagePerfilURL"
                                ref="clipper3"
                                :rotate="degrees"
                                :round="true"
                                preview="preview">
                        </clipper-fixed>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-layout row wrap class="justify-center">
                            <v-flex xs12>
                                <v-slider
                                        class="justify-center mr-3"
                                        v-model="degrees"
                                        :label="$t('grados')"
                                        step="1"
                                        max="180"
                                        min="-180"
                                        thumb-label="always"
                                ></v-slider>
                            </v-flex>
                            <v-btn
                                    color="primary"
                                    @click="get_image_recortada_perfil()"
                            >{{$t('recortar')}}</v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-layout align-center justify-center fill-height>
                <v-dialog v-model="dialog" scrollable persistent max-width="550px">
                    <template v-slot:activator="{ on }">
                        <v-btn
                                color="primary"
                                dark
                                v-on="on"
                                @click="update = false,
                                clean_fields()"> + {{ $t('anadir_administrador') }}
                        </v-btn>
                        <v-btn
                                arrow_upward
                                color="primary"
                                @click="clear(), dialog_move_up = true,
                                clean_fields_move_up()"
                        >
                            <v-icon dark left>swap_horiz</v-icon>
                            {{$t('cambiar_permisos')}}
                        </v-btn>
                    </template>
                    <v-form
                            @submit.prevent="update
                                        ? updateAdministrador(id_update)
                                        : altaAdministrador()">
                        <v-card class="elevation-5">
                            <v-toolbar dark color="primary">
                                <v-toolbar-title>
                                    {{ $t('Administradores') }}
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn
                                        class="align-self-end"
                                        color="red"
                                        icon
                                        @click="dialog = false">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-card-text>
                                <v-autocomplete
                                        v-if="dialog" autofocus
                                        v-model="id_empresa"
                                        prepend-icon="business"
                                        name="id_empresa"
                                        item-text="name"
                                        item-value="id"
                                        :label="$t('Empresa')"
                                        :filter="customFilter"
                                        :error-messages="errores.id_empresa"
                                        :items="empresas"
                                        no-data-text="Ningún Resultado"
                                        clearable
                                ></v-autocomplete>
                                <v-text-field
                                        class="pt-3 pb-3"
                                        :placeholder="$t('lbl_position')"
                                        v-model="position"
                                        :counter="100"
                                        :maxlength="100"
                                        prepend-icon="account_tree"
                                        name="position"
                                        :label="$t('position')"
                                        :error-messages="errores.position"
                                >
                                </v-text-field>
                                <v-text-field
                                        class="pt-3 pb-3"
                                        v-model="rfid"
                                        :counter="50"
                                        :maxlength="50"
                                        prepend-icon="style"
                                        name="rfid"
                                        label="RFID"
                                        :error-messages="errores.rfid"
                                >
                                </v-text-field>
                                <v-text-field
                                        v-model="first_name"
                                        autofocus
                                        prepend-icon="person"
                                        name="first_name"
                                        :label="$t('Nombre')"
                                        :error-messages="errores_seg.first_name"
                                >
                                </v-text-field>
                                <v-text-field
                                        v-model="last_name"
                                        prepend-icon="person_outline"
                                        name="last_name"
                                        :label="$t('Apellido')"
                                        :error-messages="errores_seg.last_name"
                                >
                                </v-text-field>
                                <v-layout row wrap class="text-sm-center">
                                    <v-flex xs12 sm6 class="ingla pt-3 pb-3 pl-3 pr-3">
                                        <v-label>
                                            {{$t('foto_ine')}}<br>[{{$t('frente')}}]
                                        </v-label>
                                        <br>
                                        <v-img
                                                class="pt-3 pb-3"
                                                :src="resultIneFrenteURL"
                                                v-if="resultIneFrenteURL"
                                                width="auto"
                                                height="180"
                                        ></v-img>
                                        <br>
                                        <v-btn
                                                color="primary">
                                            <clipper-upload
                                                    @input="dialog = false, dialog_img_frontal = true, degrees = 0, ratio = 1"
                                                    accept="image/*"
                                                    v-model="imageIneFrenteURL"
                                            >
                                                {{$t('subir_imagen')}}
                                            </clipper-upload>
                                        </v-btn>
                                        <br>
                                        <v-alert
                                                :value="errores_seg.ine_frente"
                                                type="error"
                                                outline
                                                transition="scale-transition"
                                        >
                                            {{errores_seg.ine_frente}}
                                        </v-alert>
                                    </v-flex>
                                    <v-flex xs12 sm6 class="ingla pt-3 pb-3 pl-3 pr-3">
                                        <v-label>
                                            {{$t('foto_ine')}}<br>[{{$t('atras')}}]
                                        </v-label>
                                        <br>
                                        <v-img
                                                class="pt-3 pb-3"
                                                :src="resultIneAtrasURL"
                                                v-if="resultIneAtrasURL"
                                                width="auto"
                                                height="180"
                                        ></v-img>
                                        <br>
                                        <v-btn
                                                color="primary">
                                            <clipper-upload
                                                    @input="dialog = false, dialog_img_atras = true, degrees = 0, ratio = 1"
                                                    accept="image/*"
                                                    v-model="imageIneAtrasURL"
                                            >
                                                {{$t('subir_imagen')}}
                                            </clipper-upload>
                                        </v-btn>
                                        <br>
                                        <v-alert
                                                :value="errores_seg.ine_atras"
                                                type="error"
                                                outline
                                                transition="scale-transition"
                                        >
                                            {{errores_seg.ine_atras}}
                                        </v-alert>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap class="text-sm-center">
                                    <v-flex xs12 sm6 class="ingla pt-3 pb-3 pl-3 pr-3">
                                        <v-label>
                                            {{$t('foto_perfil')}}
                                        </v-label>
                                        <br>
                                        <v-img
                                                class="pt-3 pb-3"
                                                :src="resultPerfilURL"
                                                v-if="resultPerfilURL"
                                                width="auto"
                                                height="180"
                                        ></v-img>
                                        <br>
                                        <v-btn
                                                color="primary">
                                            <clipper-upload
                                                    @input="dialog = false, dialog_img_perfil = true, degrees = 0, ratio = 1"
                                                    accept="image/*"
                                                    v-model="imagePerfilURL"
                                            >
                                                {{$t('subir_imagen')}}
                                            </clipper-upload>
                                        </v-btn>
                                        <br>
                                        <v-alert
                                                :value="errores_seg.avatar"
                                                type="error"
                                                outline
                                                transition="scale-transition"
                                        >
                                            {{errores_seg.avatar}}
                                        </v-alert>
                                    </v-flex>
                                </v-layout>
                                {{$t('celular')}}
                                <vue-tel-input
                                        class="mt-3 mb-3"
                                        v-model="celular"
                                        @onInput="onInput"
                                ></vue-tel-input>
                                <!--                                    <v-alert v-if="errores_seg.celular" type="error">{{errores_seg.celular}}</v-alert>-->
                                <v-alert
                                        :value="errores_seg.celular"
                                        color="error"
                                        icon="warning"
                                        outline
                                >
                                    {{errores_seg.celular}}
                                </v-alert>
                                <v-layout row wrap>
                                    <v-flex v-bind:class="(update) ? 'xs12 sm6 md6 lg6 xl6' : 'xs12 sm12 md12 lg12 xl12'">
                                        <v-text-field
                                                v-model="email"
                                                prepend-icon="email"
                                                name="email"
                                                label="E-Mail"
                                                :error-messages="errores_seg.email"
                                        >
                                        </v-text-field>
                                    </v-flex>
<!--                                    <v-flex v-show="update" v-bind:class="(update) ? 'xs12 sm6 md6 lg6 xl6' : 'xs12 sm12 md12 lg12 xl12'">-->
<!--                                        <v-checkbox-->
<!--                                                v-model="activa"-->
<!--                                                name="activa"-->
<!--                                                :label="$t('Activo')"-->
<!--                                                :error-messages="errores.activa"-->
<!--                                        ></v-checkbox>-->
<!--                                    </v-flex>-->
                                </v-layout>
                                <v-checkbox
                                        v-model="change_password"
                                        v-if="update" disable
                                        name="change_password"
                                        label="Cambiar Contraseña"
                                ></v-checkbox>
                                <v-text-field
                                        v-model="password"
                                        :disabled="update && !change_password ? true: false"
                                        name="password"
                                        prepend-icon="lock"
                                        :label="$t('password')"
                                        :type="show ? 'text' : 'password'"
                                        :append-icon="show ? 'visibility' : 'visibility_off'"
                                        :error-messages="errores_seg.password"
                                        data-vv-name="password"
                                        ref="password"
                                        @click:append="show = !show">
                                </v-text-field>
                                <v-text-field
                                        v-validate="change_password ? 'required|confirmed:password': ''"
                                        v-model="confirm_password"
                                        :disabled="update  && !change_password ? true: false"
                                        name="confirm_password"
                                        prepend-icon="lock"
                                        :label="$t('password_confirm')"
                                        :type="show ? 'text' : 'password'"
                                        :append-icon="show ? 'visibility' : 'visibility_off'"
                                        :error-messages="errors.collect('confirm_password')"
                                        @click:append="show = !show"
                                        data-vv-name="confirm_password">
                                </v-text-field>
                                <v-alert
                                        :value=alerta
                                        type="warning"
                                        outline
                                        transition="scale-transition"
                                >
                                    Fallo con el Servidor
                                </v-alert>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn
                                        color="primary"
                                        @click="clear(),
                                            dialog = false"
                                >{{$t('cerrar')}}
                                </v-btn>
                                <v-spacer/>
                                <v-btn
                                        v-if="update"
                                        :loading="loading"
                                        color="primary"
                                        type="submit"
                                >{{$t('modificar')}}
                                </v-btn>
                                <v-btn
                                        v-else
                                        :loading="loading"
                                        color="primary"
                                        type="submit"
                                >{{$t('agregar')}}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-dialog>
            </v-layout>
            <v-layout class="my-4" align-center justify-center fill-height>
                <v-flex >
                    <v-card-title>
                        {{$t('Administradores')}}
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="searchAdmin"
                                append-icon="search"
                                :label="$t('search_by_many_fields')"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="headers"
                            :loading="loading_data_administradores"
                            :items="administradores"
                            :search="searchAdmin"
                            class="elevation-1"
                    >
                        <template v-slot:items="props">
                            <td class="justify-center layout px-0">
                                <v-icon
                                        medium
                                        class="mr-2"
                                        @click="fill_fields(props.item),
                                        update = true,
                                        dialog = true,
                                        id_update = props.item.id"
                                >
                                    edit
                                </v-icon>
                            </td>
                            <td>{{ props.item.id_usuario.first_name }}</td>
                            <td>{{ props.item.id_usuario.last_name }}</td>
                            <td>{{ props.item.id_usuario.celular }}</td>
                            <td>{{ props.item.id_usuario.email }}</td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                            </v-alert>
                        </template>>
                        <template v-slot:pageText="props">
                            {{props.rowsPerPage}}
                            {{$t('Administradores')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    import { Validator } from 'vee-validate'
    import VuejsClipper from 'vuejs-clipper'
    import { mapState, mapGetters} from 'vuex'
    import ClipperFixed from "vuejs-clipper/src/components/clipper-fixed"

    Vue.use(VeeValidate)
    Vue.use(VuejsClipper ,{
        components: {
            clipperBasic: 'clipper-basic',
            clipperFixed: 'clipper-fixed',
            clipperUpload: 'clipper-upload'
        }
    })

    const dictionary = {
        en: {
            messages:{
                confirmed: () => 'The passwords didn\'t match',
                required: () => 'This field is required'
            }
        },
        es: {
            messages: {
                confirmed: () => 'Las contraseñas no coinciden',
                required: () => 'Este campo es requerido'
            }
        }
    };
    Validator.localize(dictionary);
    const validator = new Validator({ confirm_password: 'confirmed' });
    // Falta investigar como cambiar el idioma de los mensajes
    // con vue-validate
    // validator.localize(this.$store.state.language);
    validator.localize('es');

    export default {
        name: "administradores",
        components: {ClipperFixed},
        created: function(){
            this.get_administradores()
            this.get_empresas()
        },
        data: () => ({
            show: false,
            alerta: false,
            dialog: false,
            update: false,
            id_update: 0,
            id_empresa: '',
            first_name: '',
            last_name: '',
            celular: '',
            email: '',
            password: '',
            errores: [],
            errores_seg: [],
            headers: [],
            empresas: [],
            administradores: [],
            activa: '',
            change_password: '',
            loading_data_administradores: false,
            confirm_password: '',
            dialog_move_up: false,
            email2: null,
            id_empresa2: null,
            search2: null,
            isLoading: false,
            entries: [],
            loading: false,
            dialogCellNumberWrong: false,
            band_cellphone: true,
            dialog_img_frontal: false,
            dialog_img_atras: false,
            dialog_img_perfil: false,
            // Variables imagen recortada
            imageIneFrenteURL: '',
            imageIneAtrasURL: '',
            imagePerfilURL: '',
            resultIneFrenteURL: '',
            resultIneAtrasURL: '',
            resultPerfilURL: '',
            resultAuxIneFrenteURL: '',
            resultAuxIneAtrasURL: '',
            resultAuxPerfilURL: '',
            emailAux: '',
            celularAux: '',
            degrees: 0,
            ratio: 1,
            position: '',
            rfid: '',
            searchAdmin:''
        }),
        beforeUpdate(){
            this.headers = [
                {
                    text: this.$t('modificar'),
                    align: 'left',
                    sortable: false,
                    value: 'update'
                },
                {
                    text: this.$t('Nombre'),
                    align: 'left',
                    sortable: true,
                    value: 'id_usuario.first_name'
                },
                {
                    text: this.$t('Apellido'),
                    align: 'left',
                    sortable: true,
                    value: 'id_usuario.last_name'
                },
                {
                    text: this.$t('celular'),
                    align: 'left',
                    sortable: true,
                    value: 'id_usuario.celular'
                },
                {
                    text: 'E-Mail',
                    align: 'left',
                    sortable: true,
                    value: 'id_usuario.email'
                }
            ]
        },
        computed: {
            ...mapState(['language']),
            fields () {
                if (!this.email2) return []

                return Object.keys(this.email2).map(key => {
                    return {
                        key,
                        value: this.email2[key] || 'n/a'
                    }
                })
            },
            items () {
                return this.entries.map(entry => {
                    const email = entry.email.length > this.descriptionLimit
                        ? entry.email.slice(0, this.descriptionLimit) + '...'
                        : entry.email

                    return Object.assign({}, entry, { email })
                })
            }
        },
        watch: {
            isUpdating (val) {
                if (val) {
                    setTimeout(() => (this.isUpdating = false), 3000)
                }
            },
            search2 (val) {
                // Items have already been loaded
                //if (this.items.length > 0) return

                // Items have already been requested
                //if (this.isLoading) return
                if (val.length > 2){

                    this.isLoading = true

                    // Lazily load input items
                    const config = {
                        method: 'get',
                        url: 'https://empresa-service.intrare.app/simpleUser/filter?search=' + val,
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': 'Token ' + store.getters.getToken
                        }
                    };
                    axios(config)
                        .then(response => {
                            console.log(response.data)
                            if(this.entries.length > 0){
                                for(var i =0 ; i < response.data.length; i++){
                                    this.entries.push(response.data[i])
                                }
                            }
                            else
                                this.entries = response.data
                        })
                        .catch(error => {
                            console.log(error)
                        })
                        .finally(() => (this.isLoading = false))
                }
            }
        },
        methods: {
            get_empresas: function(){

                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.empresas = response.data
                    })
                    .catch(error => {
                        console.log(error)
                    })

            },
            get_administradores: function(){
                this.loading_data_administradores = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/administradores/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.administradores = response.data
                        this.loading_data_administradores = false
                    })
                    .catch(error => {
                        this.loading_data_administradores = false
                        console.log(error)
                    })

            },
            altaAdministrador: function () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        if (this.band_cellphone === true) {
                            this.loading = true
                            if ( this.id_empresa === undefined) {
                                this.id_empresa = ''
                            }
                            this.errores = []
                            this.errores_seg = []
                            var bodyFormData = new FormData()
                            var file = null
                            var file2 = null
                            var file3 = null

                            bodyFormData.set('id_usuario.first_name', this.first_name)
                            bodyFormData.set('id_usuario.last_name', this.last_name)
                            bodyFormData.set('id_usuario.celular', this.celular)
                            bodyFormData.set('id_usuario.username', this.celular)
                            bodyFormData.set('id_usuario.email', this.email.toLowerCase())
                            bodyFormData.set('id_usuario.password', this.password)
                            bodyFormData.set('id_usuario.roll', 5)
                            bodyFormData.set('id_usuario.is_active', true)
                            bodyFormData.set('id_empresa', this.id_empresa)
                            if (this.position === '') {
                              this.position = null
                            }
                            bodyFormData.set('position', this.position)
                            if (this.rfid === '') {
                              this.rfid = null
                            }
                            bodyFormData.set('rfid', this.rfid)
                            if (this.resultIneFrenteURL != '' && this.resultIneFrenteURL.length > 6) {
                                file = this.dataURLtoFile(this.resultIneFrenteURL, 'ine_front.jpeg')
                            }
                            bodyFormData.append('id_usuario.ine_frente', file)
                            if (this.resultIneAtrasURL != '' && this.resultIneAtrasURL.length > 6) {
                                file2 = this.dataURLtoFile(this.resultIneAtrasURL, 'ine_back.jpeg')
                            }
                            bodyFormData.append('id_usuario.ine_atras', file2)
                            if (this.resultPerfilURL != '' && this.resultPerfilURL.length > 6) {
                                file3 = this.dataURLtoFile(this.resultPerfilURL, 'avatar.jpeg')
                            }
                            bodyFormData.append('id_usuario.avatar', file3)
                            const config = {
                                method: 'post',
                                url: 'https://empresa-service.intrare.app/empresas/administradores/',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept-Language': this.language ,
                                    'authorization': 'Token ' + store.getters.getToken
                                },
                                data: bodyFormData
                            };
                            axios(config)
                                .then(ok => {
                                    this.loading = false
                                    this.get_administradores()
                                    this.$store.commit('snackbar_activate_true')
                                    this.$store.commit('snackbar_change_message', this.$t('mensaje_administrador_alta'))
                                    this.dialog = false
                                    setTimeout(this.clear, 3000);
                                })
                                .catch(error => {
                                    this.loading = false
                                    if(error.response.status == 400
                                        && typeof error.response.data == "object"
                                        && error.response.data) {
                                        if(error.response.data)
                                            this.errores = error.response.data
                                        if(error.response.data.id_usuario)
                                            this.errores_seg = error.response.data.id_usuario
                                    }
                                })
                        } else {
                            this.dialog = false
                            this.dialogCellNumberWrong = true
                        }
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });
            },
            updateAdministrador: function (id) {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        if (this.band_cellphone === true) {
                            this.loading = true
                            var bodyFormData = new FormData()
                            var file = null
                            var file2 = null
                            var file3 = null

                            if (this.id_empresa === undefined) {
                                this.id_empresa = ''
                            }
                            this.errores = []
                            this.errores_seg = []
                            if (this.emailAux !== this.email) {
                                bodyFormData.set('id_usuario.email', this.email.toLowerCase())
                            }
                            if (this.celularAux !== this.celular) {
                                bodyFormData.set('id_usuario.celular', this.celular)
                                bodyFormData.set('id_usuario.username', this.celular)
                                // idUser['cellNumber'] = this.celular
                            }
                            if (this.change_password === true) {
                                bodyFormData.set('id_usuario.password', this.password)
                                // idUser['password'] = this.password
                            }
                            bodyFormData.set('id_usuario.first_name', this.first_name)
                            bodyFormData.set('id_usuario.last_name', this.last_name)
                            // bodyFormData.set('id_usuario.is_active', this.activa)

                            if( this. resultAuxIneFrenteURL !== this.resultIneFrenteURL) {
                                if (this.resultIneFrenteURL != '' && this.resultIneFrenteURL.length > 6) {
                                    file = this.dataURLtoFile(this.resultIneFrenteURL, 'ine_front_update.jpeg')
                                }
                                bodyFormData.append('id_usuario.ine_frente', file)
                            }
                            if( this. resultAuxIneAtrasURL !== this.resultIneAtrasURL) {
                                if (this.resultIneAtrasURL != '' && this.resultIneAtrasURL.length > 6) {
                                    file2 = this.dataURLtoFile(this.resultIneAtrasURL, 'ine_back_update.jpeg')
                                }
                                bodyFormData.append('id_usuario.ine_atras', file2)
                            }
                            if( this. resultAuxPerfilURL !== this.resultPerfilURL) {
                                if (this.resultPerfilURL != '' && this.resultPerfilURL.length > 6) {
                                    file3 = this.dataURLtoFile(this.resultPerfilURL, 'avatar_update.jpeg')
                                }
                                bodyFormData.append('id_usuario.avatar', file3)
                            }
                            if (this.position === '' || this.position === null) {
                                this.position = ''
                            }
                            // console.log('Valor Position = ', this.position)
                            bodyFormData.set('position', this.position)
                            if (this.rfid === '' || this.rfid === null) {
                                this.rfid = ''
                            }
                            // console.log('Valor rfid = ', this.rfid)
                            bodyFormData.set('rfid', this.rfid)
                            bodyFormData.set('id_empresa', this.id_empresa)
                            const config = {
                                method: 'patch',
                                url: 'https://empresa-service.intrare.app/empresas/administradores/'+ id +'/update/',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept-Language': this.language ,
                                    'authorization': 'Token ' + store.getters.getToken
                                },
                                data: bodyFormData
                            };
                            axios(config)
                                .then(ok => {
                                    this.loading = false
                                    this.get_administradores()
                                    this.$store.commit('snackbar_activate_true')
                                    this.$store.commit('snackbar_change_message', this.$t('mensaje_administrador_modificado'))
                                    this.dialog = false
                                    setTimeout(this.clear, 3000);
                                })
                                .catch(error => {
                                    this.loading = false
                                    console.log(error.response.data)
                                    if(error.response.status == 400
                                        && typeof error.response.data == "object"
                                        && error.response.data) {
                                        if(error.response.data)
                                            this.errores = error.response.data
                                        if(error.response.data.id_usuario)
                                            this.errores_seg = error.response.data.id_usuario
                                    }
                                })
                        } else {
                            this.dialog = false
                            this.dialogCellNumberWrong = true
                        }
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });
            },
            change_user_to_manager(){
                this.errores = {}
                if (this.email2 === undefined){
                    this.email2 = null
                }
                if (this.id_empresa2 === undefined){
                    this.id_empresa2 = null
                }
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.loading = true
                        const config = {
                            method: 'PATCH',
                            url: 'https://empresa-service.intrare.app/upgradeUserToAdmin/',
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: {
                                idUsuario: this.email2,
                                idEmpresa: this.id_empresa2
                            }
                        };
                        axios(config)
                            .then(ok => {
                                this.loading = false
                                this.get_administradores()
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('msg_cambio_permisos'))
                                this.dialog_move_up = false
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                this.loading = false
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data){
                                    this.errores = error.response.data
                                }
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });
            },
            clear: function () {
                this.alerta = false
                this.errores = []
                this.errores_seg = []
                this.$validator.reset()
                this.$store.commit('snackbar_change_color', 'success')
                this.$store.commit('snackbar_activate_false')
            },
            fill_fields(item){
                console.log(item.id_usuario.ine_frente)

                if (item.position === '' || item.position === null) {
                  this.position = null
                } else {
                    this.position = item.position
                }

                if (item.rfid === '' || item.rfid === null) {
                  this.rfid = null
                } else {
                    this.rfid = item.rfid
                }
                this.id_empresa = item.id_empresa
                this.first_name = item.id_usuario.first_name
                this.last_name = item.id_usuario.last_name
                if (item.id_usuario.celular.length <= 10) {
                    console.log('Algo anda mal')
                    this.onInput ({number: {e164: item.id_usuario.celular}}, false, null)
                } else {
                    this.band_cellphone = true
                    this.celular = item.id_usuario.celular
                }
                this.email = item.id_usuario.email
                this.celularAux = item.id_usuario.celular
                this.emailAux = item.id_usuario.email
                // this.activa = item.id_usuario.is_active
                this.password = ''
                this.confirm_password = ''
                this.ine_frente_imageName = ''
                this.ine_atras_imageName = ''
                this.resultIneFrenteURL = item.id_usuario.ine_frente
                this.resultIneAtrasURL = item.id_usuario.ine_atras
                this.resultPerfilURL = item.id_usuario.avatar

                this.resultAuxIneFrenteURL = item.id_usuario.ine_frente
                this.resultAuxIneAtrasURL = item.id_usuario.ine_atras
                this.resultAuxPerfilURL = item.id_usuario.avatar
                this.change_password = false
                this.errores = []
                this.errores_seg = []
            },
            customFilter (item, queryText) {
                const textOne = item.name.toLowerCase()
                const searchText = queryText.toLowerCase()
                return textOne.indexOf(searchText) > -1
            },
            clean_fields(){
                this.id_empresa = ""
                this.first_name = ""
                this.last_name = ""
                this.celular = ""
                this.email = ""
                this.position = ''
                this.rfid = ''
                this.password = ""
                this.confirm_password = ""
                this.change_password = true
                this.celularAux = ''
                this.emailAux = ''
                this.ine_frente_imageName = ''
                this.ine_frente_imageFile = ''
                this.resultIneFrenteURL = ''
                this.resultPerfilURL = ''
                this.ine_atras_imageName = ''
                this.ine_atras_imageFile = ''
                this.resultIneAtrasURL = ''
            },
            clean_fields_move_up(){
                this.email2 = null
                this.id_empresa2 = null
            },
            pickFile_ine_frente () {
                this.$refs.image_ine_frente.click ()
            },
            onFilePicked_ine_frente (e) {
                const files = e.target.files
                if(files[0] !== undefined) {
                    this.ine_frente_imageName = files[0].name
                    if(this.ine_frente_imageName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader ()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.ine_frente_imageUrl = fr.result
                        this.ine_frente_imageFile = files[0] // this is an image file that can be sent to server...
                    })
                } else {
                    this.ine_frente_imageName = ''
                    this.ine_frente_imageFile = ''
                    this.ine_frente_imageUrl = ''
                }
            },
            pickFile_ine_atras () {
                this.$refs.image_ine_atras.click ()
            },
            onFilePicked_ine_atras (e) {
                const files = e.target.files
                if(files[0] !== undefined) {
                    this.ine_atras_imageName = files[0].name
                    if(this.ine_atras_imageName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader ()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.ine_atras_imageUrl = fr.result
                        this.ine_atras_imageFile = files[0] // this is an image file that can be sent to server...
                    })
                } else {
                    this.ine_atras_imageName = ''
                    this.ine_atras_imageFile = ''
                    this.ine_atras_imageUrl = ''
                }
            },
            get_image_recortada() {
                console.log('Datos de la imagen = ', this.imageIneFrenteURL.size)
                const canvas = this.$refs.clipper.clip();//call component's clip method
                this.resultIneFrenteURL = canvas.toDataURL("image/jpeg", 0.2);//canvas->image
                console.log(this.resultIneFrenteURL)
                this.dialog_img_frontal = false
                this.dialog = true
            },
            get_image_recortada_atras() {
                const canvas = this.$refs.clipper2.clip();//call component's clip method
                this.resultIneAtrasURL = canvas.toDataURL("image/jpeg", 0.2);//canvas->image
                console.log(this.resultIneAtrasURL)
                this.dialog_img_atras = false
                this.dialog = true
            },
            get_image_recortada_perfil() {
                const canvas = this.$refs.clipper3.clip();//call component's clip method
                this.resultPerfilURL = canvas.toDataURL("image/jpeg", 0.2);//canvas->image
                console.log(this.resultPerfilURL)
                this.dialog_img_perfil = false
                this.dialog = true
            },
            dataURLtoFile(dataurl, filename) {
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, {type:mime});
            },
            onInput ({ number, isValid, country }) {
                console.log(number.e164)
                console.log(isValid)
                console.log(country)
                this.celular = number.e164
                this.band_cellphone = isValid
            }
        }
    }
</script>

<style scoped>
    .ingla {
        border-radius: 2px;
        border-color: #002b48 #002b48 #002b48 #002b48;
        border-width: 2px 2px 2px 2px;
        border-style: solid solid solid solid;
    }
</style>
